export default __webpack_public_path__ + "static/media/ellipse_5.e7e6afe69c1c7f9af63ac1116aa41bbf.svg";